//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    const searchCategories = [
        {
            text: t('homePage.searchForTypo.typology1Text'),
            imgPath: "/assets/images/inHome/tipologie/appartamento.webp",
            link: "immobili/appartamento"
        },
        {
            text: t('homePage.searchForTypo.typology2Text'),
            imgPath: "/assets/images/inHome/tipologie/villa.webp",
            link: "immobili/villa"
        },
        {
            text: t('homePage.searchForTypo.typology3Text'),
            imgPath: "/assets/images/inHome/tipologie/terratetto.webp",
            link: "immobili/terratetto"
        },
        {
            text: t('homePage.searchForTypo.typology4Text'),
            imgPath: "/assets/images/inHome/tipologie/rustico.webp",
            link: "immobili/casale"
        }
    ]
    
        
    return (
        <section id="searchForTipology" className="space-pt">
            <h2 className="text-center">{t('homePage.searchForTypo.title')}</h2>
            <div className="container-fluid">
                <div className="row p-3">
                    {searchCategories.map((category, index) => (
                        <div key={index} className="col-12 col-lg-6 p-0">
                            <Link to={category.link} title={category.text}>
                                <div className="tipology-card">
                                    <img src={category.imgPath} alt={category.text} />
                                    <h5 className="card-title">{category.text}</h5>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
